import { render } from "./TranslatedText.vue?vue&type=template&id=79f0c1d5&scoped=true&ts=true"
import script from "./TranslatedText.vue?vue&type=script&lang=ts"
export * from "./TranslatedText.vue?vue&type=script&lang=ts"

import "./TranslatedText.vue?vue&type=style&index=0&id=79f0c1d5&lang=scss&scoped=true"

import exportComponent from "/opt/atlassian/pipelines/agent/build/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-79f0c1d5"]])

export default __exports__